import { AlertStyled } from "@/components/AlertStyled";
import CheckboxStyled from "@/components/CheckboxStyled";
import { TextFieldPasswordStyled } from "@/components/TextFieldPasswordStyled";
import TextFieldStyled from "@/components/TextFieldStyled";
import { registerUser } from "@/lib/auth";
import { passwordValidation as validatePassword } from "@/lib/validation";
import { basierCirleBold } from "@/styles/fonts";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import theme from "../../styles/theme";

export default function RegisterForm() {
  const MIN_PW_LENGTH = 8;
  const DEFAULT_VALUES = {
    username: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
    consent_agb: "",
  };
  const [formValues, setFormValues] = useState(DEFAULT_VALUES);
  const [formValid, setFormValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [passwordValidation, setPasswordValidation] = useState({});

  useEffect(() => {
    setFormValid(
      formValues.email.length > 2 &&
        formValues.newPassword.length >= MIN_PW_LENGTH &&
        formValues.newPassword === formValues.confirmPassword &&
        formValues.consent_agb === true &&
        formValues.consent_privacy === true,
    );
  }, [formValues]);

  const handleInputChanged = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleCheckboxChanged = (event) => {
    const { name, checked } = event.target;
    setFormValues({
      ...formValues,
      [name]: checked,
    });
  };

  const handlePasswordInputChanged = (event) => {
    const { name, value } = event.target;
    const newValues = { ...formValues, [name]: value };
    setFormValues(newValues);

    const validationData = validatePassword(newValues, {
      ...passwordValidation,
    });

    setPasswordValidation(validationData);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    registerUser(formValues.email, formValues.email, formValues.newPassword)
      .then((res) => {
        // set authed user in global context object
        //setCreatedUser(res.data.user);

        //appContext.setUser(res.data.user);

        //createProfile(res.data.user);
        setErrorMessage(null);
      })
      .catch((error) => {
        setErrorMessage(
          error?.response?.data?.message[0]?.messages[0]?.message ??
            error.message,
        );
      });
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit}>
        <Grid container alignItems="center" justify="center" columnSpacing={3}>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              component="p"
              sx={{
                mt: 4,
                mb: 1,
                "&.MuiTypography-root": {
                  color: theme.palette.common.black,
                },
              }}
            >
              Registrieren
            </Typography>
          </Grid>
          {errorMessage && (
            <Grid item xs={12}>
              <AlertStyled severity="error" text={errorMessage} />
            </Grid>
          )}
          <Grid item xs={12}>
            <TextFieldStyled
              required={true}
              type="email"
              label="E-Mail Adresse"
              name="email"
              value={formValues.email}
              onChange={handleInputChanged}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldPasswordStyled
              required={true}
              hint={`(Mind. ${MIN_PW_LENGTH} Zeichen) `}
              label="Passwort"
              name="newPassword"
              value={formValues.newPassword}
              onChange={handlePasswordInputChanged}
              helpertext={passwordValidation?.newPassword}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldPasswordStyled
              required={true}
              label="Passwort wiederholen"
              name="confirmPassword"
              value={formValues.confirmPassword}
              onChange={handlePasswordInputChanged}
              helpertext={passwordValidation?.confirmPassword}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              "& .MuiTypography-root": {
                color: theme.palette.common.black,
              },
            }}
          >
            <Typography
              variant="h5"
              component="p"
              sx={{
                mt: 4,
              }}
            >
              Das Kleingedruckte
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontFamily: basierCirleBold.style.fontFamily,
                fontWeight: basierCirleBold.style.fontWeight,
                textTransform: "uppercase",
              }}
            >
              AGBs & Datenschutz
            </Typography>
            <Box
              sx={{
                mt: 1,
                [theme.breakpoints.up("sm")]: {
                  mt: 0,
                },
                "& label:first-of-type": {
                  mb: 2,
                  [theme.breakpoints.up("sm")]: {
                    mb: 0,
                  },
                },
              }}
            >
              <CheckboxStyled
                required={true}
                label="Hiermit bestätige ich, dass ich die AGBs gelesen habe und diese akzeptiere."
                name="consent_agb"
                checked={formValues.consent_agb}
                onChange={handleCheckboxChanged}
              />
              <CheckboxStyled
                required={true}
                label="Hiermit bestätige ich, dass ich die Datenschutzbestimmungen gelesen habe und diese akzeptiere."
                name="consent_privacy"
                onChange={handleCheckboxChanged}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ mt: 4 }}>
            <Button
              variant="contained"
              fullWidth
              color="secondary"
              type="submit"
              disabled={!formValid}
            >
              Registrieren
            </Button>
          </Grid>
        </Grid>
      </form>
    </React.Fragment>
  );
}
